class Animations {
    constructor() {
        // this._init();
    }

    _init() {
        this._setInitialStates();
        this._animateHeader();
        this._animateStats();

        gsap.registerPlugin(ScrollTrigger);
    }

    _setInitialStates() {

        // split header-cta h2 into letters
        const headline = document.querySelector('#main-headline');

        // If headline exists, split it into letters but keep the <br> tag

        if (headline) {
            const headlineText = headline.innerHTML;

            // Check if the headline contains a <br> tag and if so, replace it with a placeholder
            if (headlineText.includes('<br>')) {
                headline.innerHTML = headlineText.replace('<br>', '|');
            }
            const headlineArr = headlineText.split('');
            headline.innerHTML = '';
            headlineArr.forEach(letter => {

                if (letter === '|') {
                    const br = document.createElement('br');
                    headline.appendChild(br);
                    return;
                }

                const span = document.createElement('span');
                span.textContent = letter;
                headline.appendChild(span);
            });
        }

        gsap.set('.top-row', { opacity: 0, y: 15 })

        if (document.querySelector('#home-animation'))
            gsap.set('#home-animation', { opacity: 0 })

        if (document.querySelector('#main-headline'))
            gsap.set('.header-cta p', { opacity: 0, y: 50, rotateX: -80, scale: 0.6 })

        if (document.querySelector('.header-cta'))
            gsap.set('.header-cta .button', { opacity: 0, y: 20 })

        if (document.querySelector('#main-headline'))
            gsap.set('#main-headline', { opacity: 0, y: 30, })

        if (document.querySelector('#main-headline span'))
            gsap.set('#main-headline span', { opacity: 0, y: 30 })

        if (document.querySelector('#header-divider-svg'))
            gsap.set('#header-divider-svg', { opacity: 1, y: 30 })

        if (document.querySelector('.header-infobar'))
            gsap.set('.header-infobar .header-infobar-item', { opacity: 0, y: 50 })

        if (document.querySelector('.the-stats'))
            gsap.set('.the-stats .col-6', { opacity: 0.5, y: 40, scale: 0.8 })

        if (document.querySelector('.stats-description-text'))
            gsap.set('.stats-description-text', { opacity: 0, y: 50, rotateX: -80, scale: 0.6, x: 80 })

        if (document.querySelector('.what-is-fagura')) {
            gsap.set('.what-is-fagura h2', { opacity: 0, x: -40 })
            gsap.set('.what-is-fagura p', { opacity: 0, y: 60 })
            gsap.set('.what-is-fagura .button', { opacity: 0, y: 60 })
            gsap.set('.what-is-fagura svg', { opacity: 0, x: (jQuery(window).outerWidth() > 768 ? 90 : 0), y: 80, rotationY: 45, rotationX: jQuery(window).outerWidth() > 768 ? -90 : 0 })
        }


        // gsap.set('.user-reviews-list li', { opacity: 0, x: -30, y: 80, rotationY: 45, rotationX: -90 })

        if (document.querySelector('.user-reviews-section h2'))
            gsap.set('.user-reviews-section h2', { opacity: 0, x: -40 })

        if (document.querySelector('.user-reviews-section .section-description'))
            gsap.set('.user-reviews-section .section-description', { opacity: 0, x: -40 })

        if (document.querySelector('.apps-section'))
            gsap.set('.apps-section img', { opacity: 0, y: 120, scale: 0.4, rotateX: -90, rotateY: 35 })

        if (document.querySelector('.apps-section')) {
            gsap.set('.apps-section h2', { opacity: 0, x: -80 })
            gsap.set('.apps-section p', { opacity: 0, x: -40 })
            gsap.set('.apps-section .app-store-link', { opacity: 0, y: 40, rotateY: -45, rotateX: -40 })
            gsap.set('.apps-section .play-store-link', { opacity: 0, y: 140, rotateY: -45, rotateX: -40 })
        }

        if (document.querySelector('.new-to-investment'))
            gsap.set('.new-to-investment', { opacity: 0, y: 50, rotateX: -80, scale: 0.6 })

        if (document.querySelector('.quick-links-grid a'))
            gsap.set('.quick-links-grid a', { opacity: 0, x: -30, y: 80, rotationY: 45, rotationX: -90 })

        if (document.querySelector('.partners-list'))
            gsap.set('.partners-list div', { opacity: 0, y: 40 })

        if (document.querySelector('.contact-buble'))
            gsap.set('.contact-buble', { opacity: 0, y: 50, rotateX: -80, scale: 0.6 })

        if (document.querySelector('.loan-list')) {
            gsap.set('.loan-list .loan-line-item', { opacity: 0, x: -20, y: 40, rotateY: 15 })
            gsap.set('.loan-list .invest-list-item', { opacity: 0, x: -20, y: 40, rotateY: 15 })
        }

        if (document.querySelector('.how-it-happens'))
            gsap.set('.how-it-happens .grid .box', { opacity: 0, x: -40, y: 20, rotateY: 5 })

        if (document.querySelector('.fagura-stats-line'))
            gsap.set('.fagura-stats-line .col-3', { opacity: 0, y: 20 })

        if (document.querySelector('.why-fagura-imprumuta'))
            gsap.set('.why-fagura-imprumuta .box-white', { opacity: 0, y: 20 })

        if (document.querySelector('.contact-options')) {
            gsap.set('.contact-options div:first-child', { opacity: 0, x: -60 })
            gsap.set('.contact-options div:last-child', { opacity: 0, x: 60 })
            gsap.set('.contact-options div:nth-child(2)', { opacity: 0, y: 40 })
        }

        if (document.querySelector('#menu-footer-menu > li'))
            gsap.set('#menu-footer-menu > li', { opacity: 0, y: 40 })

        if (document.querySelector('.circle-list-item .circle'))
            gsap.set('.about-content .circle-list-item .circle', { opacity: 0, x: -80 })

        if (document.querySelector('.circle-list-item .text'))
            gsap.set('.about-content .circle-list-item .text', { opacity: 0, x: -80 })

        if (document.querySelector('.team-section .team-member'))
            gsap.set('.team-section .team-member', { opacity: 0, x: -80, rotateY: -10 })

        if (jQuery(window).width() > 768) {
            if (document.querySelector('.blog-section article'))
                gsap.set('.blog-section article', { opacity: 0, x: -30, y: 20, rotationY: 15, rotationX: -45 })
        }

    }


    _animateHeader() {

        const tl = gsap.timeline();


        tl.to('.top-row', {
            opacity: 1,
            x: 0,
            y: 0,
            rotationX: 0,
            rotationY: 0,
            scale: 1,
        });



        // Check if #home-animation exists and if so, animate it
        if (document.querySelector('#home-animation')) {
            tl.to('#home-animation', {
                opacity: 1,
                duration: 0.4,
                ease: 'ease-in'
            });
        }

        // Check if #main-headline exists and if so, animate it
        if (document.querySelector('#main-headline')) {

            tl.to('#main-headline', {
                opacity: 1,
                y: 0
            }).to('#main-headline span', {
                opacity: 1,
                y: 0,
                duration: 1.5,
                ease: 'expo.out',
                stagger: 0.01
            })
        }

        // If .header-cta exists, animate it
        if (document.querySelector('.header-cta')) {
            tl.to('.header-cta p', {
                opacity: 1,
                x: 0,
                y: 0,
                rotationX: 0,
                rotationY: 0,
                scale: 1,

            }, '-=1.9')

            tl.to('.header-cta .button', {
                opacity: 1,
                x: 0,
                y: 0,
                ease: 'power.out',

            }, '-=2')
        }

        if (document.querySelector('#header-divider-svg')) {

            tl.to('#header-divider-svg', {
                opacity: 1,
                y: 0,
                ease: 'power.out',
                duration: 1
            }, '-=2.0')
        }




        // Get all the .header-infobar-item elements and loop through them
        if (document.querySelector('.header-infobar-item')) {
            const headerInfobarItems = document.querySelectorAll('.header-infobar .header-infobar-item');
            headerInfobarItems.forEach((item, index) => {
                tl.to(item, {
                    opacity: 1,
                    y: 0,
                    duration: 2,
                    ease: 'expo.out',
                    stagger: 0.01
                }, '-=1.9')
            });
        }
    }

    _animateStats() {

        const tl = gsap.timeline();

        // Get all the .header-infobar-item elements and loop through them
        const headerInfobarItems = document.querySelectorAll('.the-stats .col-6');
        if (headerInfobarItems.length > 0) {
            headerInfobarItems.forEach((item, index) => {
                tl.to(item, {
                    opacity: 1,
                    y: 0,
                    duration: 0.5,
                    ease: 'expo.out',
                    stagger: 0.01,
                    scale: 1,
                    delay: 0.005 * index,
                    scrollTrigger: {
                        trigger: '.fagura-stats',
                        // markers: true,
                        scrub: 1,
                        start: "-600px center",
                        end: "20px center"
                    }
                }, '-=0.2')
            });
        }

        if (document.querySelector('.what-is-fagura')) {


            tl.to('.what-is-fagura h2', {
                opacity: 1,
                x: 0,
                scrollTrigger: {
                    trigger: '.what-is-fagura',
                    // markers: true,
                    scrub: 1,
                    start: "top center",
                    end: "40px top"
                }
            })
            tl.to('.what-is-fagura p', {
                opacity: 1,
                y: 0,
                scrollTrigger: {
                    trigger: '.what-is-fagura',
                    // markers: true,
                    scrub: 1,
                    start: "top center",
                    end: "40px top"
                }
            })
            tl.to('.what-is-fagura .button', {
                opacity: 1,
                y: 0,
                scrollTrigger: {
                    trigger: '.what-is-fagura',
                    // markers: true,
                    scrub: 1,
                    start: "top center",
                    end: "40px top"
                }
            })
            tl.to('.what-is-fagura svg', {
                opacity: 1,
                x: 0,
                y: 0,
                rotationX: 0,
                rotationY: 0,
                scrollTrigger: {
                    trigger: '.what-is-fagura',
                    // markers: true,
                    scrub: 1,
                    start: "top bottom",
                    end: "40px center"
                }
            })
        }

        if (document.querySelector('.user-reviews-list li')) {


            tl.to('.user-reviews-list li', {
                opacity: 1,
                x: 0,
                y: 0,
                rotationX: 0,
                rotationY: 0,
                stagger: 0.1,
                scrollTrigger: {
                    trigger: '.user-reviews-section',
                    // markers: true,
                    scrub: 1,
                    start: "top bottom",
                    end: "40px center"
                }
            })
            tl.to('.user-reviews-section h2', {
                opacity: 1,
                x: 0,
                y: 0,
                rotationX: 0,
                rotationY: 0,
                scrollTrigger: {
                    trigger: '.user-reviews-section',
                    // markers: true,
                    scrub: 1,
                    start: "-60px bottom",
                    end: "80px center"
                }
            })
            tl.to('.user-reviews-section .section-description', {
                opacity: 1,
                x: 0,
                y: 0,
                rotationX: 0,
                rotationY: 0,
                scrollTrigger: {
                    trigger: '.user-reviews-section',
                    // markers: true,
                    scrub: 1,
                    start: "-60px bottom",
                    end: "80px center"
                }
            })
        }

        if (document.querySelector('.apps-section')) {
            tl.to('.apps-section img', {
                opacity: 1,
                x: 0,
                y: 0,
                rotationX: 0,
                rotationY: 0,
                scale: 1,
                scrollTrigger: {
                    trigger: '.apps-section',
                    // markers: true,
                    scrub: 1,
                    start: "-60px bottom",
                    end: "80px center"
                }
            })
            tl.to('.apps-section h2', {
                opacity: 1,
                x: 0,
                y: 0,
                rotationX: 0,
                rotationY: 0,
                scale: 1,
                scrollTrigger: {
                    trigger: '.apps-section',
                    // markers: true,
                    scrub: 1,
                    start: "-60px bottom",
                    end: "80px center"
                }
            })
            tl.to('.apps-section p', {
                opacity: 1,
                x: 0,
                y: 0,
                rotationX: 0,
                rotationY: 0,
                scale: 1,
                delay: 0.8,
                scrollTrigger: {
                    trigger: '.apps-section',
                    // markers: true,
                    scrub: 1,
                    delay: 0.8,
                    start: "-40px bottom",
                    end: "80px center"
                }
            })
            tl.to('.apps-section .app-store-link', {
                opacity: 1,
                x: 0,
                y: 0,
                rotationX: 0,
                rotationY: 0,
                scale: 1,
                delay: 0.8,
                scrollTrigger: {
                    trigger: '.apps-section',
                    // markers: true,
                    scrub: 1,
                    delay: 0.8,
                    start: "-40px bottom",
                    end: "80px center"
                }
            })
            tl.to('.apps-section .play-store-link', {
                opacity: 1,
                x: 0,
                y: 0,
                rotationX: 0,
                rotationY: 0,
                scale: 1,
                delay: 0.8,
                scrollTrigger: {
                    trigger: '.apps-section',
                    // markers: true,
                    scrub: 1,
                    delay: 0.8,
                    start: "-20px bottom",
                    end: "40px center"
                }
            }, '-=0.5')

        }

        if (document.querySelector('.new-to-investment'))
            tl.to('.new-to-investment', {
                opacity: 1,
                x: 0,
                y: 0,
                rotationX: 0,
                rotationY: 0,
                scale: 1,
                delay: 0.8,
                // transformOrigin: '50% 0',
                scrollTrigger: {
                    trigger: '.new-to-investment',
                    // markers: true,
                    scrub: 1,
                    delay: 0.8,
                    start: "-200px bottom",
                    end: "-200px center"
                }
            })
        if (document.querySelector('.quick-links-grid'))
            tl.to('.quick-links-grid a', {
                opacity: 1,
                x: 0,
                y: 0,
                rotationX: 0,
                rotationY: 0,
                stagger: 0.1,
                scrollTrigger: {
                    trigger: '.quick-links-grid',
                    // markers: true,
                    scrub: 1,
                    start: "top bottom",
                    end: "40px center"
                }
            })
        if (jQuery(window).width() > 768) {
            if (document.querySelector('.blog-section article'))
                tl.to('.blog-section article', {
                    opacity: 1,
                    x: 0,
                    y: 0,
                    rotationX: 0,
                    rotationY: 0,
                    stagger: 0.1,
                    scrollTrigger: {
                        trigger: '.blog-section',
                        // markers: true,
                        scrub: 1,
                        start: "top bottom",
                        end: "40px center"
                    }
                })
        }

        if (document.querySelector('.partners-list'))
            tl.to('.partners-list div', {
                opacity: 1,
                x: 0,
                y: 0,
                rotationX: 0,
                rotationY: 0,
                stagger: 0.1,
                scrollTrigger: {
                    trigger: '.parent-partners-section',
                    // markers: true,
                    scrub: 1,
                    start: "top bottom",
                    end: "40px center"
                }
            })

        if (document.querySelector('.loan-list')) {

            tl.to('.loan-list .loan-line-item', {
                opacity: 1,
                x: 0,
                y: 0,
                rotationX: 0,
                rotationY: 0,
                stagger: 0.1,
                scrollTrigger: {
                    trigger: '.loan-list',
                    // markers: true,
                    scrub: 1,
                    start: "-120px bottom",
                    end: "20px center"
                }
            })
            tl.to('.loan-list .invest-list-item', {
                opacity: 1,
                x: 0,
                y: 0,
                rotationX: 0,
                rotationY: 0,
                stagger: 0.1,
                scrollTrigger: {
                    trigger: '.loan-list',
                    // markers: true,
                    scrub: 1,
                    start: "-120px bottom",
                    end: "20px center"
                }
            })
        }

        if (document.querySelector('.contact-buble'))
            tl.to('.contact-buble', {
                opacity: 1,
                x: 0,
                y: 0,
                rotationX: 0,
                rotationY: 0,
                scale: 1,
                delay: 0.8,
                // transformOrigin: '50% 0',
                scrollTrigger: {
                    trigger: '.contact-section',
                    // markers: true,
                    scrub: 1,
                    delay: 0.8,
                    start: "-200px bottom",
                    end: "-200px center"
                }
            })

        if (document.querySelector('.stats-description-text'))
            tl.to('.stats-description-text', {
                opacity: 1,
                x: 0,
                y: 0,
                rotationX: 0,
                rotationY: 0,
                scale: 1,
                delay: 0.8,
                // transformOrigin: '50% 0',
                scrollTrigger: {
                    trigger: '.fagura-stats',
                    // markers: true,
                    scrub: 1,
                    delay: 0.8,
                    start: "-40px bottom",
                    end: "-100px center"
                }
            })
        if (document.querySelector('.how-it-happens'))
            tl.to('.how-it-happens .grid .box', {
                opacity: 1,
                x: 0,
                y: 0,
                rotationX: 0,
                rotationY: 0,
                scale: 1,
                delay: 0.8,
                stagger: 0.2,
                // transformOrigin: '50% 0',
                scrollTrigger: {
                    trigger: '.how-it-happens',
                    // markers: true,
                    scrub: 1,
                    delay: 0.8,
                    start: "-40px bottom",
                    end: "-100px center"
                }
            })

        if (document.querySelector('.fagura-stats-line'))
            tl.to('.fagura-stats-line .col-3', {
                opacity: 1,
                x: 0,
                y: 0,
                rotationX: 0,
                rotationY: 0,
                scale: 1,
                delay: 0.8,
                stagger: 0.2,
                // transformOrigin: '50% 0',
                scrollTrigger: {
                    trigger: '.fagura-stats-line',
                    // markers: true,
                    scrub: 1,
                    delay: 0.8,
                    start: "-40px bottom",
                    end: "-100px center"
                }
            })

        if (document.querySelector('.why-fagura-imprumuta'))
            tl.to('.why-fagura-imprumuta .box-white', {
                opacity: 1,
                x: 0,
                y: 0,
                rotationX: 0,
                rotationY: 0,
                scale: 1,
                delay: 0.8,
                stagger: 0.2,
                // transformOrigin: '50% 0',
                scrollTrigger: {
                    trigger: '.why-fagura-imprumuta',
                    // markers: true,
                    scrub: 1,
                    delay: 0.8,
                    start: "top bottom",
                    end: "bottom center"
                }
            })
        if (document.querySelector('.contact-options')) {
            tl.to('.contact-options div:first-child', {
                opacity: 1,
                x: 0,
                y: 0,
                rotationX: 0,
                rotationY: 0,
                scale: 1,
                delay: 0.8,
                stagger: 0.2,
                // transformOrigin: '50% 0',
                scrollTrigger: {
                    trigger: '.contact-section',
                    // markers: true,
                    scrub: 1,
                    delay: 0.8,
                    start: "top bottom",
                    end: "bottom center"
                }
            })
            tl.to('.contact-options div:last-child', {
                opacity: 1,
                x: 0,
                y: 0,
                rotationX: 0,
                rotationY: 0,
                scale: 1,
                delay: 0.8,
                stagger: 0.2,
                // transformOrigin: '50% 0',
                scrollTrigger: {
                    trigger: '.contact-section',
                    // markers: true,
                    scrub: 1,
                    delay: 0.8,
                    start: "top bottom",
                    end: "bottom center"
                }
            })
            tl.to('.contact-options div:nth-child(2)', {
                opacity: 1,
                x: 0,
                y: 0,
                rotationX: 0,
                rotationY: 0,
                scale: 1,
                delay: 0.8,
                stagger: 0.2,
                // transformOrigin: '50% 0',
                scrollTrigger: {
                    trigger: '.contact-section',
                    // markers: true,
                    scrub: 1,
                    delay: 0.8,
                    start: "top bottom",
                    end: "bottom center"
                }
            })
        }

        if (document.querySelector('#menu-footer-menu > li'))
            tl.to('#menu-footer-menu > li', {
                opacity: 1,
                x: 0,
                y: 0,
                rotationX: 0,
                rotationY: 0,
                scale: 1,
                delay: 0.8,
                stagger: 0.2,
                // transformOrigin: '50% 0',
                scrollTrigger: {
                    trigger: '#colophon',
                    // markers: true,
                    scrub: 1,
                    delay: 0.8,
                    start: "top bottom",
                    end: "-300px center"
                }
            })

        if (document.querySelector('.circle-list-item .circle')) {
            tl.to('.circle-list-item .circle', {
                opacity: 1,
                x: 0,
                y: 0,
                rotationX: 0,
                rotationY: 0,
                scale: 1,
                delay: 0.8,
                stagger: 0.2,
                // transformOrigin: '50% 0',
                scrollTrigger: {
                    trigger: '.about-content',
                    // markers: true,
                    scrub: 1,
                    delay: 0.8,
                    start: "top bottom",
                    end: "bottom center"
                }
            })
            tl.to('.circle-list-item .text', {
                opacity: 1,
                x: 0,
                y: 0,
                rotationX: 0,
                rotationY: 0,
                scale: 1,
                delay: 0.8,
                stagger: 0.2,
                // transformOrigin: '50% 0',
                scrollTrigger: {
                    trigger: '.about-content',
                    // markers: true,
                    scrub: 1,
                    delay: 0.8,
                    start: "top bottom",
                    end: "bottom center"
                }
            })
        }

        if (document.querySelector('.team-section .team-member'))
            tl.to('.team-section .team-member', {
                opacity: 1,
                x: 0,
                y: 0,
                rotationX: 0,
                rotationY: 0,
                scale: 1,
                delay: 0.8,
                stagger: 0.2,
                // transformOrigin: '50% 0',
                scrollTrigger: {
                    trigger: '.team-section',
                    // markers: true,
                    scrub: 1,
                    delay: 0.8,
                    start: "top bottom",
                    end: "bottom center"
                }
            })
    }





}



const animations = new Animations();
document.addEventListener('DOMContentLoaded', () => {
    animations._init();
});